import { Box, Grid, GridItem, GridProps, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';

type DetailsGridProps = {
  children: ReactNode;
} & GridProps;

export const DetailsGrid = (props: DetailsGridProps) => {
  return (
    <Grid templateColumns="120px 1fr" rowGap={3} columnGap={2} {...props}>
      {props.children}
    </Grid>
  );
};

interface DetailsGridRowProps {
  title: ReactNode;
  children: ReactNode;
  'data-testid'?: string;
  isDetailsPage?: boolean;
}

export const DetailsGridRow = ({
  title,
  children,
  isDetailsPage,
  'data-testid': dataTestId,
}: DetailsGridRowProps) => {
  return isDetailsPage ? (
    <Box w="100%">
      <GridItem
        display="flex"
        alignItems="start"
        data-testid={dataTestId ? `${dataTestId}-label` : undefined}
      >
        <Text color="text.secondary">{title}</Text>
      </GridItem>
      <GridItem
        display="flex"
        flex="1"
        alignItems="center"
        data-testid={dataTestId ? `${dataTestId}-value` : undefined}
      >
        {children}
      </GridItem>
    </Box>
  ) : (
    <>
      <GridItem
        display="flex"
        alignItems="start"
        data-testid={`${dataTestId}-label`}
      >
        <span color="text.secondary">{title}</span>
      </GridItem>
      <GridItem
        display="flex"
        flex="1"
        alignItems="center"
        data-testid={`${dataTestId}-value`}
      >
        {children}
      </GridItem>
    </>
  );
};
